import styled from 'styled-components';

export const BorderLeft = styled.div`
  position: absolute;
  height: calc(100% - 24px);
  width: 8px;
  background: #f0f0f0;
  border-radius: ${props => props.theme.radius.md};
`;

export const Wrapper = styled.div`
  width: 100%;

  span {
    font-size: ${props => props.theme.font.size.xs};
  }

  .ant-pagination {
    margin-top: 16px;
    margin-bottom: 0;
    > li {
      min-width: 23px;
      height: 23px;
      line-height: 22px;
      .ant-select > .ant-select-selector {
        min-width: 22px;
        height: 23px;
        line-height: 22px;
        > .ant-select-selection-item {
          line-height: 22px;
        }
      }
    }
  }
`;
